import React from "react";

function SortableListWrapper({ children }) {
    return <ul className="moveTools">{children}</ul>;
}

export default SortableListWrapper;
